export default "__VITE_ASSET__48734a48__"